import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Eye, TrendingUp } from 'lucide-react';
import { approachContent } from '../data/mock';

const ApproachSection = () => {
  const pillars = [
    { icon: Shield, label: 'Ethical', description: 'Responsible AI practices' },
    { icon: Eye, label: 'Efficient', description: 'Optimized solutions' },
    { icon: TrendingUp, label: 'Future-Ready', description: 'Scalable strategies' }
  ];

  return (
    <section className="section section-alt" id="approach">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="caption mb-4 inline-block" style={{ color: 'var(--accent-primary)' }}>
              Our Philosophy
            </span>
            <h2 className="heading-1 mb-6">{approachContent.title}</h2>
            <p className="body-large mb-6">
              {approachContent.description}
            </p>
            <div
              className="body-medium italic pl-4"
              style={{ 
                borderLeft: '2px solid var(--accent-primary)',
                color: 'var(--text-muted)'
              }}
            >
              {approachContent.tagline}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid gap-4"
          >
            {pillars.map((pillar, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="card flex items-center gap-4"
              >
                <div className="icon-container">
                  <pillar.icon size={20} />
                </div>
                <div>
                  <h3 className="heading-3 mb-1">{pillar.label}</h3>
                  <p className="body-small">{pillar.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
